module.exports = __webpack_public_path__ + "img/2.6f7cd732.webp";